import _extends from "@babel/runtime/helpers/extends";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import styled from 'styled-components';
import { getAssetIcon } from 'utils/icons';
import getImageUrlSuffix from 'utils/image/getImageUrlSuffix';
import AssetIcon from 'components/AssetIcon';
import Box from 'components/Box';
import ButtonCore from 'components/ButtonCore';
import useBreakpoints from 'hooks/useBreakpoints';
import Card from 'components/Card';
import CardImage from 'components/CardImage';
import CenterContent from 'components/CenterContent';
import ViewMoreText from 'components/ViewMoreText';
var maxPanelWidth = 420;
var pictureUrlSuffix = getImageUrlSuffix({
  width: maxPanelWidth
});
var ButtonBlock = styled(ButtonCore).withConfig({
  displayName: "ButtonPanel__ButtonBlock",
  componentId: "sc-15scbde-0"
})(["display:block;width:100%;"]);
function ButtonPanel(_ref) {
  var asset = _ref.asset,
    imageButtonProps = _ref.imageButtonProps,
    children = _ref.children;
  var description = asset.description,
    pictureUrl = asset.pictureUrl;
  var _useBreakpoints = useBreakpoints(),
    isDesktop = _useBreakpoints.xs;
  var assetIcon = getAssetIcon(asset);
  var hasCard = pictureUrl || description;
  return /*#__PURE__*/React.createElement(CenterContent, {
    contentWidth: maxPanelWidth,
    fillParent: isDesktop,
    height: isDesktop ? null : 200
  }, hasCard && /*#__PURE__*/React.createElement(Card, null, pictureUrl && /*#__PURE__*/React.createElement(ButtonBlock, _extends({}, imageButtonProps, {
    "aria-hidden": "true",
    role: "presentation",
    tabIndex: "-1"
  }), /*#__PURE__*/React.createElement(CardImage, {
    lazyload: false,
    src: pictureUrl && pictureUrl + pictureUrlSuffix,
    colorBlock: assetIcon,
    aspectRatio: 2 / 3,
    fallbackContent: /*#__PURE__*/React.createElement(AssetIcon, {
      name: assetIcon,
      size: "big"
    })
  })), description && /*#__PURE__*/React.createElement(Box, {
    p: "s",
    pb: "m",
    fontSize: "s"
  }, /*#__PURE__*/React.createElement(ViewMoreText, {
    content: description,
    maxLength: isDesktop ? 400 : 90
  }))), /*#__PURE__*/React.createElement(Box, {
    textAlign: "center",
    mt: hasCard ? '-s' : null
  }, children));
}
export default ButtonPanel;